import { ValidatorFn } from '@angular/forms';
import { AutocompleteQuestion } from './question-autocomplete';
import { CheckboxQuestion } from './question-checkbox';
import { DatePickerQuestion } from './question-datepicker';
import { DropdownQuestion } from './question-dropdown';
import { EmptyQuestion } from './question-empty';
import { ExpandableQuestion } from './question-expandable';
import { FiniteListMultiSelectQuestion } from './question-finite-list-multi-select';
import { MultiSelectQuestion } from './question-multi-select';
import { MultiselectQuestion } from './question-multiselect';
import { QuarterQuestion } from './question-quarter';
import { RadioQuestion } from './question-radio';
import { SearchMultiSelectQuestion } from './question-search-multi-select';
import { SwitchQuestion } from './question-switch';
import { TextareaQuestion } from './question-textarea';
import { TextboxQuestion } from './question-textbox';
import { UploadQuestion } from './question-upload';

export interface QuestionControlOptions<T> {
  key?: string;
  label?: string;
  value?: T;
  required?: boolean;
  readonly?: boolean;
  order?: number;
  columnClass?: string;
  controlType?: string;
  validators?: ValidatorFn[];
  matchQuestionKey?: string;
  isValid?: boolean;
  isHidden?: boolean;
  group?: {
    ordering?: number;
    label?: string;
  };
}

export class QuestionBase<T = any> {
  key: string;
  label: string;
  value: T;
  required: boolean;
  readonly: boolean;
  order: number;
  columnClass: string;
  controlType: string;
  validators: ValidatorFn[];
  // TODO: Refactor into form level validators object
  matchQuestionKey: string;
  isValid: boolean;
  isHidden: boolean;
  group: {
    ordering: number;
    label?: string;
  };

  constructor(options: QuestionControlOptions<T> | any) {
    this.key = options.key;
    this.label = options.label;
    this.value = options.value;
    this.required = !!options.required;
    this.readonly = !!options.readonly;
    this.order = options.order === undefined ? 1 : options.order;
    this.columnClass = options.columnClass || 'is-one-fifth';
    this.controlType = options.controlType || '';
    this.validators = options.validators;
    this.matchQuestionKey = options.matchQuestionKey;
    this.isValid = options.isValid || false;
    this.isHidden = options.isHidden || false;
    this.group = options.group || {
      ordering: 0,
      label: ''
    };
  }
}

export interface Question<T = any>
  extends QuestionBase<T>,
    AutocompleteQuestion<T>,
    CheckboxQuestion,
    DatePickerQuestion,
    DropdownQuestion,
    EmptyQuestion,
    ExpandableQuestion<T>,
    FiniteListMultiSelectQuestion,
    MultiselectQuestion<T>,
    MultiSelectQuestion<T>,
    QuarterQuestion,
    RadioQuestion,
    SearchMultiSelectQuestion,
    SwitchQuestion,
    TextareaQuestion,
    TextboxQuestion,
    UploadQuestion {
  value: any;
  type: any;
  options: any;
}
